export const LOCATION_CURRENT_LATITUDE = 'currentLatitude';
export const LOCATION_CURRENT_LONGITUDE = 'currentLongitude';
